import boldPlugins from "./bold";
import breakPlugins from "./break";
import italicPlugins from "./italic";
import linkPlugins from "./link";
import underlinePlugins from "./underline";

export default [boldPlugins, breakPlugins, italicPlugins, linkPlugins, underlinePlugins];
